import React, { useReducer} from 'react';

import CyclistContext from '../context/cyclist-context';
import LocationContext from '../context/location-context';
import PostContext from '../context/post-context';
import cyclistReducer from '../reducers/cyclist';
import postReducer from '../reducers/post';
import locationReducer, { DEFAULT_LOCATION_REDUCER } from '../reducers/location';
import MapPanel from '../components/MapPanel/MapPanel';
// import PostsPanel from '../components/PostsPanel';

const RakNRollApp = props => {

  const [cyclists, dispatchCyclists] = useReducer(cyclistReducer, []);
  const [locations, dispatchLocations] = useReducer(locationReducer, DEFAULT_LOCATION_REDUCER);
  // const [gps, dispatchGps] = useReducer(locationReducer, DEFAULT_LOCATION_REDUCER);
  const [posts, dispatchPosts] = useReducer(postReducer, []);

  return (
    <>
      <CyclistContext.Provider value={{cyclists, dispatchCyclists}}>
        <LocationContext.Provider value={{locations, dispatchLocations}}>
          <MapPanel></MapPanel>
        </LocationContext.Provider>
        {/* <PostContext.Provider value={{posts, dispatchPosts}}>
          <MapPanel></MapPanel>
          <PostsPanel></PostsPanel>
        </PostContext.Provider> */}
      </CyclistContext.Provider>
    </>
  );
};

export { RakNRollApp as default }